export default __webpack_public_path__ + "static/media/background.37ea64fe.jpg";